import React from "react"
import PropTypes from "prop-types"
import { MdArrowForward } from "react-icons/md"

import { hexToRGBA } from "gatsby-interface"
import { ClassNames } from "@emotion/core"

const ReadMore = ({ className }) => (
  <ClassNames>
    {({ cx }) => {
      return (
        <div
          css={theme => ({
            alignItems: `center`,
            background: theme.colors.gatsby,
            border: `1px solid ${hexToRGBA(
              theme.colors.blue[10],
              0.275,
              true
            )}`,
            borderRadius: theme.radii[2],
            color: theme.colors.white,
            display: `inline-flex`,
            fontSize: theme.fontSizes[1],
            padding: `${theme.space[3]} ${theme.space[3]} ${theme.space[3]} ${theme.space[4]}`,
            marginTop: theme.space[7],
            whiteSpace: `nowrap`,
            [theme.mediaQueries.desktop]: {
              marginTop: theme.space[10],
            },
          })}
          className={cx("read-more", className)}
        >
          Learn more
          {` `}
          <MdArrowForward css={theme => ({ marginLeft: theme.space[2] })} />
        </div>
      )
    }}
  </ClassNames>
)

ReadMore.propTypes = {
  className: PropTypes.string,
}

export default ReadMore
